export enum KeyboardKeysEnum {
  ARROW_DOWN = "ArrowDown",
  ARROW_UP = "ArrowUp",
  ENTER = "Enter",
}

export enum FormStepsEnum {
  ACCOUNT_VERIFICATION = 0,
  SERVICE_FIELDS = 1,
}

export type TGetSettings = {
  countries: Array<TCountry>;
  isDemoClientsAllowed: boolean;
};

export type TCountry = { code: string; prefix: number };
